import React, { memo } from "react";
import { Button } from "react-bootstrap";

import { InfoIcon } from "../../../../components/icons";
import { TrashIcon } from "../../../../components/icons/TrashIcon";
import { CacheTypeTag } from "../CacheTypeTag/CacheTypeTag";
import { Latency } from "../Latency";

interface INoCacheMessageProps {
  deleteMessage: (id: number | string) => void;
  id: number | string;
  status: number;
  latency: number | null | undefined;
}

const errors: {
  [key: string]: { role: string; description: React.ReactNode };
} = {
  "400": {
    role: "assistant",
    description: (
      <span>
        The response was filtered due to the prompt triggering Azure
        OpenAI&apos;s content management policy. Please modify your prompt and
        retry. To learn more about our content filtering policies please read
        our documentation: &nbsp;
        <a
          href="https://go.microsoft.com/fwlink/?linkid=2198766"
          target="_blank"
          rel="noreferrer"
        >
          https://go.microsoft.com/fwlink/?linkid=2198766
        </a>
      </span>
    ),
  },
  "504": {
    role: "warning",
    description: (
      <span>
        No cached response found, and no answer retrieved from the LLM due to
        the Cache-Control directive being set to <code>only-if-cached</code>.
      </span>
    ),
  },
};

const ErrorMessage: React.FC<INoCacheMessageProps> = memo(
  ({ deleteMessage, id, status, latency }) => {
    const deleteMessageHandler = () => {
      deleteMessage(id);
    };

    return (
      <div className="playground-message error-message">
        <div className="playground-message-header">
          <div className="playground-message-role error-message">
            {errors[String(status)]?.role}
          </div>
          <div className="playground-message-controls">
            {status === 504 && <CacheTypeTag type="only-if-cached" />}
            <Latency latency={latency ?? null} />
            <Button
              variant="outline-light"
              onClick={deleteMessageHandler}
              data-testid="delete"
            >
              <TrashIcon />
            </Button>
          </div>
        </div>
        <div className="editor-wrapper">
          <div className="editor">
            <p>
              <span className="icon-container">
                <InfoIcon />
              </span>
              {errors[String(status)]?.description}
            </p>
          </div>
        </div>
      </div>
    );
  },
);

export { ErrorMessage };
